

































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/ServiceRequestDetails.scss';
import { ServiceRequest, RequestStatus, Route, GPSLocation } from '../types/entity';
import { ApiRequest, CancelRequest, EditParticipantRequest } from '../types/request';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '../config/objectFactory';
import { DateUtils } from '../util/dateUtils';
import GoogleMap from '../components/GoogleMap.vue';
import RescheduleRequestModal from './modal/RescheduleRequestModal.vue';
import MessageBox from '../components/MessageBox.vue';
import { required, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { MathUtils } from '@/util/mathUtils';
import { MemberProfile } from '@/types/response';
import BaseCard from '../components/BaseCard.vue';
import CardCell from '../components/CardCell.vue';
import Dropdown from '../components/Dropdown.vue';
import FareDetails from '../components/FareDetails.vue';
import ApproveAuctionModal from './modal/ApproveAuctionModal.vue';
import UploadLienCustomerDocument from '../views/modal/UploadLienCutomerDocument.vue';
import ViewFeedbackModal from '../views/modal/ViewFeedbackModal.vue';
import { CommonUtils } from '@/util/commonUtils';
@Component({
    mixins: [validationMixin],
    props: {
        id: String,
    },
    components: {
        GoogleMap,
        RescheduleRequestModal,
        MessageBox,
        BaseCard,
        CardCell,
        Dropdown,
        ApproveAuctionModal,
        FareDetails,
        UploadLienCustomerDocument,
        ViewFeedbackModal,
    },
    data() {
        return {
            cancelationReason: '',
            reasons: [
                { value: 'R00009', text: 'Appointment Rescheduled' },
                { value: 'R00011', text: 'Incorrect Pick up address provided' },
                { value: 'R00010', text: 'Passenger Provided Own Transportation' },
                { value: 'R00012', text: 'Passenger Refused Transportation' },
                { value: 'R00008', text: 'Passenger Unreachable' },
                { value: 'R00001', text: 'This entry was a test' },
            ],
            comments: '',
            participantEmail: '',
            blobURL: '',
        };
    },
    validations: {
        cancelationReason: {
            required,
        },
        participantEmail: {
            email,
        },
    },
    watch: {
        'id'(newId) {
            const obj = this as ServiceRequestDetails;
            obj.getRequestDetails();
        },
        '$route.path'(to, from) {
            if (!to.endsWith(MedTransGoConstants.URL_RESCHEDULE_REQUEST)
                && !to.includes(MedTransGoConstants.URL_NEW_SERVICE_REQUEST)) {
                const obj = this as ServiceRequestDetails;
                obj.getRequestDetails();
            }
        },
    },
})
export default class ServiceRequestDetails extends Vue {

    private serviceRequest: ServiceRequest = {
        additionalNotes: '',
        appointment: {
            date: '',
            facility: {
                name: '',
                email: '',
                address: {},
            },
            patient: {
                fullName: '',
                email: '',
                phone: '',
                address: {},
            },
            timestamp: '',
            timezone: '',
        },
        assignment: {
            history: [],
        },
        billingLocation: {
            address: {},
            name: '',
        },
        createdOn: '',
        payment: {},
        status: '',
        transportRequest: {
            conciergeService: false,
            estimatedVisitTime: { hours: '', minutes: '' },
            routes: [],
            transport: '',
            vehicleType: '',
            visitType: '',
            isBariatricServiceRequired: '',
        },
        id: '',
    } as any;
    private DateUtils = DateUtils;
    private cancelEvent = false;
    private showCancelationReasonModal = false;
    private cancelationReason = null;
    private currentStatus: RequestStatus = 'Pending';
    private requestStatusArray: RequestStatus[] = [];
    private currentStatusTimestamp = 0;
    private currentStatusIndex: number = 0;
    private showInvoice = false;
    private MathUtils = MathUtils;
    private showChangeInterpreterConfirmation = false;
    private depositAmount = 0;
    private isFormValid = false;
    private showFeedback = false;
    private participants: string[] = [];
    private mapRoutes: Route[] = [
        {
            pickupAddress: {
                fullAddress: '',
                latitude: 0,
                longitude: 0,
                zip: '',
                country: '',
                city: '',
                state: '',
                locality: '',
            },
            dropoffAddress: {
                fullAddress: '',
                latitude: 0,
                longitude: 0,
                zip: '',
                country: '',
                city: '',
                state: '',
                locality: '',
            },
            totalMiles: 0,
            duration: 0,
            fare: {
                particulars: [],
                totalAmount: 0,
            } as any,
            pickupTime: 0,
            expectedArrivalTime: 0,
            estimatedPayout: 0,
            status: '',
            createdOn: '' as any,
            lastModifiedOn: 0,
            transporterId: '',
            driverId: '',
            driverName: '',
            id: '',
            transporterCompany: '',
            googleMap: {},
            routeId: '',
        } as any,
    ];
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private isLoading = true;
    private isRouteLoading = true;
    private isRouteRefreshing = false;
    private showUploadDocumentForm = false;

    public async mounted() {
        const id = this.$props.id || this.$route.params.id;
        if (id) {
            await this.getRequestDetails();
        }
        this.validateForm();
    }

    get inProgressRoute() {
        if (this.mapRoutes && this.mapRoutes.length) {
            for (const route of this.mapRoutes) {
                if (route.status === 'In-Progress' && route.tripDetails) {
                    return route;
                }
            }
        }
        return null;
    }

    private async refreshRouteLocation() {
        if (this.inProgressRoute) {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${this.inProgressRoute.id}`,
            };
            this.isRouteRefreshing = true;
            const response = await iHttpService.get<Route>(apiRequest);
            this.isRouteRefreshing = false;
            if (response.success && response.data) {
                const route = response.data;
                const existingRoute = this.mapRoutes.find((value) => {
                    return value.id === route.id;
                });
                if (existingRoute) {
                    existingRoute.status = route.status;
                    existingRoute.tripDetails = route.tripDetails;
                }
            }
        }
    }

    private async getRequestDetails() {
        this.showInvoice = false;
        const id = this.$props.id || this.$route.params.id;
        this.depositAmount = 0;
        this.isLoading = true;
        this.isRouteLoading = true;
        const response = await ObjectFactory.getRequestService().getRequestDetails(id, this.$store.state.serverUrl);
        this.isLoading = false;
        if (response.data) {
            const assignmentHistory = response.data.assignment.history;
            if (response.data.status === 'Canceled') {
                this.requestStatusArray = ['Pending'];
                assignmentHistory.forEach((history) => {
                    if (!this.requestStatusArray.includes(history.status)) {
                        this.requestStatusArray.push(history.status);
                    }
                });
            } else {
                this.requestStatusArray = ['Pending', 'Assigned', 'Confirmed', 'Completed'];
            }
            this.currentStatus = assignmentHistory[assignmentHistory.length - 1].status;
            this.currentStatusTimestamp = assignmentHistory[assignmentHistory.length - 1].timestamp;
            this.currentStatusIndex = this.requestStatusArray.indexOf(this.currentStatus);
            if (response.data.payment && response.data.payment.invoiceId) {
                const invoiceResponse = await ObjectFactory.getRequestService()
                    .getRequestInvoice(response.data.payment.invoiceId, this.$store.state.serverUrl);
                response.data.payment.invoice = invoiceResponse.data;
                this.showInvoice = true;
            } else {
                if (response.data.payment) {
                    const estimatedFare = response.data.payment.estimatedFare;
                    estimatedFare.particulars.forEach((element) => {
                        if (element.description === 'Deposit (Refundable)') {
                            this.depositAmount += element.amount;
                        }
                    });
                }
            }
            if (response.data.transportRequest) {
                this.mapRoutes = response.data.transportRequest.mapRoutes;
                response.data.transportRequest.isOxygenTankRequired =
                    response.data.transportRequest.isOxygenTankRequired ? 'Yes' : 'No' as any;
                response.data.transportRequest.mentalHealth =
                    response.data.transportRequest.mentalHealth ? 'Yes' : 'No' as any;
                response.data.transportRequest.caregiver =
                    response.data.transportRequest.caregiver ? 'Yes' : 'No' as any;
                response.data.transportRequest.isBariatricServiceRequired =
                    response.data.transportRequest.isBariatricServiceRequired ? 'Yes' : 'No' as any;
                response.data.transportRequest.rideshareService =
                    response.data.transportRequest.rideshareService ? 'Yes' : 'No' as any;
                for (const route of this.mapRoutes) {
                    if (route.status === 'In-Progress' && route.tripDetails) {
                        setInterval(this.refreshRouteLocation, 20000);
                        break;
                    }
                }
            }
            if (response.data.deliveryRequest) {
                this.mapRoutes = response.data.deliveryRequest.mapRoutes;
            }
            this.serviceRequest = response.data;
            if (response.data.cmrRequest) {
                this.serviceRequest.serviceType = 'Comprehensive Medication Review';
            }
            if (response.data.homeAssistanceRequest && this.serviceRequest.homeAssistanceRequest) {
                this.serviceRequest.serviceType = `${this.serviceRequest.serviceType} + Home Assistance`;
                const appointmentTimestamp =
                    DateUtils.convertToUTCInMillis(response.data.homeAssistanceRequest.appointmentDate + ' ' +
                        response.data.homeAssistanceRequest.appointmentTime, response.data.appointment.timezone);
                const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
                    DateUtils.FORMAT_DATETIME_AM_PM, response.data.appointment.timezone);
                this.serviceRequest.homeAssistanceRequest.appointmentDate = appointmentTime;
            }
            if (this.serviceRequest.deliveryRequest && this.serviceRequest.deliveryRequest.proofOfDelivery) {
                this.getProofOfDelivery(this.serviceRequest.deliveryRequest.proofOfDelivery);
            }
            this.isRouteLoading = false;
        }
    }

    private async cancelRequest(request?: any) {
        const cancelRequest: CancelRequest = {
            reason: this.$data.cancelationReason,
            comments: this.$data.comments,
        };
        const response = await ObjectFactory.getRequestService().cancelRequest(
            request.id, cancelRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.redirectToList('Canceled');
        }
        this.$data.cancelationReason = '';
        this.$data.comments = '';
        this.showCancelationReasonModal = false;
    }

    private redirectToList(status: RequestStatus) {
        let requestType = 'interpreterRequest';
        if (this.serviceRequest && this.serviceRequest.transportRequest) {
            requestType = 'transportRequest';
        } else if (this.serviceRequest && this.serviceRequest.telemedicineRequest) {
            requestType = 'telemedicineRequest';
        }
        this.$router.push({
            path: `${MedTransGoConstants.URL_REQUESTS}/${this.serviceRequest.id}`,
            query: { requestType, status },
        });
        this.getRequestDetails();
    }

    private async changeInterpreter() {
        if (this.serviceRequest.id) {
            const response = await ObjectFactory.getRequestService()
                .changeInterpreter(this.serviceRequest.id, this.$store.state.serverUrl);
            if (response.success) {
                this.redirectToList('Pending');
                this.showChangeInterpreterConfirmation = false;
            }
        }
    }

    private addParticipant() {
        if (this.participants && this.$v.participantEmail.email) {
            if (!this.participants.includes(this.$data.participantEmail)) {
                this.participants.push(this.$data.participantEmail);
            }
            this.$data.participantEmail = '';
            this.validateForm();
        }
    }

    private removeParticipant(index: number) {
        if (this.participants) {
            this.participants.splice(index, 1);
            this.validateForm();
        }
    }

    private validateForm() {
        if (this.participants) {
            this.isFormValid = this.participants.length > 0;
        }
    }

    private async editParticipant() {
        if (this.participants && this.participants.length) {
            const requestId: string = this.serviceRequest.id as any;
            const editParticipantRequest: EditParticipantRequest = {
                participants: this.participants,
            };
            const response = await ObjectFactory.getRequestService().editRequest(
                requestId, editParticipantRequest, this.$store.state.serverUrl);
            if (response) {
                this.getRequestDetails();
            }
        }
    }

    private async getProofOfDelivery(fileName: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${fileName}`,
            loaderEvent: {
                show: true,
            },
            responseType: 'arraybuffer',
        };
        const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
        if (fileBuffer.errorCode) {
            CommonUtils.showError(fileBuffer);
        } else {
            const file = new Blob([fileBuffer], { type: 'application/pdf' });
            this.$data.blobURL = URL.createObjectURL(file);
        }
    }
}
